export default __webpack_public_path__ + "static/media/gp.e72571b6.svg";